jQuery('.header__lang').on('click', function () {
  jQuery(this).toggleClass('open');
  // jQuery(this).closest('.company__box').find('.company__text').toggle();
});
